import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentItem.Find.IRequest;
type Response = Api.Finance.ContractRefundPaymentItem.Find.IResponse;
type Headers = Api.Finance.ContractRefundPaymentItem.Find.IHeaders;
const url = '/api/Finance/ContractRefundPaymentItem/:id';
export default async function contractRefundPaymentItemFindApi(params: {
  id: number;
}): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
